import styled from 'styled-components';

export const TextWrapper = styled.div`
  text-align: center;
  max-width: 350px;
  &:last-child {
    margin-top: ${({ theme }) => theme.spacing.km4};
  }
`;
